import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const fileReadUiNodeSpec: UiNodeSpec<'fileRead'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'trigger', 'filePath' ],
    }),
    cfg: () => ({
        controlValues: { encoding: 'utf-8' },
        id: getUID(),
        kind: 'fileRead',
        disabled: false,
    }),
    controls: cfgFn => {
        const cfg = cfgFn();
        return {
            encoding: {
                cfg: {
                    items: [
                        { label: 'UTF-8', value: 'utf-8' },
                        { label: 'ASCII', value: 'ascii' },
                        { label: 'Latin1', value: 'latin1' },
                        { label: 'UTF-16 LE', value: 'utf16le' },
                        { label: 'Base64', value: 'base64' },
                        { label: 'Hex', value: 'hex' },
                    ],
                    kind: 'selection',
                    label: 'Encoding',
                },
                nodeCfg: cfg,
                value: cfg.controlValues.encoding,
            },
        };
    },
    inputs: () => ({
        trigger: {
            socket: 'event',
            label: 'Trigger',
        },
        filePath: {
            socket: 'string',
            label: 'File Path',
        },
    }),
    kindLabel: 'File Read',
    nodeCategory: 'external',
    outputs: () => ({
        next: {
            socket: 'event',
            label: 'Next',
        },
        fileContents: {
            socket: 'string',
            label: 'File Contents',
        },
    }),
    validator: () => true,
};
